<template>
  <div class="job-requirement-item">
    <component :is="svgComponentName" class="job-requirement__icon" />
    <p>{{ nameLabel }}</p>
  </div>
</template>

<script>
import SvgCert from '../../../assets/svg/cert.svg?inline'
import SvgEducation from '../../../assets/svg/education.svg?inline'
import SvgSkill from '../../../assets/svg/skill.svg?inline'

export default {
  components: {
    'svg-cert': SvgCert,
    'svg-education': SvgEducation,
    'svg-skill': SvgSkill,
  },
  computed: {
    nameLabel() {
      return this.$tf(this.type, this.name)
    },
    svgComponentName() {
      return `svg-${this.type}`
    },
  },
  props: {
    name: {
      required: true,
      type: String,
    },
    type: {
      default: 'skill',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-requirement-item {
  @apply flex items-center capitalize;
}
</style>
